import React, { useRef } from 'react';
import ButtonsScroller from '../common/ButtonsScroller';
import { getConfiguration } from '../data/utils/configuration';
import { iconCategoryCssClass } from '../data/utils/iconCategoryCssClass';
import ButtonsScrollerWh from '../common/ButtonsScrollerWh';

export default function CategoriesNavbar(props) {
    const scroller = useRef(null);
    const conf = getConfiguration();
    
    return (
        <>
            {/* <div className="h-aggs-navbar-height overflow-x-auto p-2 flex items-center bg-cs7 font-medium text-xs uppercase" ref={scroller}> */}
            {conf.iwh ?
            (<div className='px-2 z-30'>
            <ButtonsScrollerWh>
            {props.categories.map(c => {
                    let icon = c.categoryIcon;
                    if (c.id === 0) {
                        icon = iconCategoryCssClass(1, 4);
                    }
                    return (
                        <div key={c.id}
                            className={"h-[24px] shrink-0 p-2 mr-2 flex items-center last:mr-0 rounded-lg " + (props.selected === c.id ? 'bg-cs4 text-cs1 xs_selected' : 'bg-cs7 text-cs8')}
                            onClick={() => props.changeCategory(c.id)}>
                            <span className={"inline-block w-[16px] h-[16px] " + icon}></span>
                            <span className="ml-1">{c.descrizione}</span>
                        </div>
                    );
                })}

            </ButtonsScrollerWh></div>)
            : (
            <ButtonsScroller>
                {props.categories.map(c => {
                    let icon = c.categoryIcon;
                    if (c.id === 0) {
                        icon = iconCategoryCssClass(1, 4);
                    }
                    return (
                        <div key={c.id}
                            className={"h-[24px] shrink-0 p-2 mr-2 flex items-center last:mr-0 rounded-lg " + (props.selected === c.id ? 'bg-cs4 text-cs1 xs_selected' : 'bg-cs7 text-cs8')}
                            onClick={() => props.changeCategory(c.id)}>
                            <span className={"inline-block w-[16px] h-[16px] " + icon}></span>
                            <span className="ml-1">{c.descrizione}</span>
                        </div>
                    );
                })}
            </ButtonsScroller>)
            }

           
            {/* </div> */}
        </>
    );
}